import { Input } from "@material-ui/core";
import React, { FC } from "react";

import { TheCycleverseTheme } from "src/theme";
import { makeStyles } from "@material-ui/core/styles";

const useStylesForSmallInput = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderRadius: "4px",
    fontWeight: 900,
    height: "38px",
    marginTop: "10px",
    marginRight: "10px",
    float: "left",
  },
  input: {
    paddingLeft: "24px",
    paddingRight: "24px",
    color: theme.palette.secondary.main,
    width: "30px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      width: "60px",
      textAlign: "center",
    },
  },
}));

export const TinyInput: FC<{
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, isTypeNumber?: boolean) => any;
  value: string;
}> = ({ name, onChange, value, ...props }) => {
  const classes = useStylesForSmallInput();

  return <Input value={value} name={name} onChange={onChange} disableUnderline={true} classes={classes} {...props} />;
};
